export default {
  development: {
    API: "https://localhost:7237/api/", // http://localhost:5237/api/  https://trial-deployment-dev.azurewebsites.net/api/  https://trial-deployment.azurewebsites.net/api/
  },
  production: {
    API: "https://trial-deployment-dev.azurewebsites.net/api/", // https://trial-deployment-dev.azurewebsites.net/api/  https://trial-deployment-prod.azurewebsites.net/api/
  },
};
